var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2736 14.0919L7.72791 9.5462L3.18222 14.0919C2.68219 14.5919 1.86397 14.5919 1.36395 14.0919C0.86392 13.5919 0.863919 12.7736 1.36395 12.2736L5.90963 7.72792L1.36394 3.18224C0.863919 2.68221 0.863919 1.86399 1.36394 1.36396C1.86397 0.863935 2.68219 0.863936 3.18222 1.36396L7.72791 5.90965L12.2736 1.36396C12.7736 0.863936 13.5918 0.863936 14.0919 1.36396C14.5919 1.86399 14.5919 2.68221 14.0919 3.18224L9.54618 7.72792L14.0919 12.2736C14.5919 12.7736 14.5919 13.5919 14.0919 14.0919C13.5918 14.5919 12.7736 14.5919 12.2736 14.0919Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.9a01897f08a4d755f09895673f07ced4.svg";
export { ForwardRef as ReactComponent };